import { defineStore } from "pinia";
import { markRaw } from "vue";

import { api, type Result } from "../api";
import {
  AddressResponseSchema,
  AddressSearchResultSchema,
  type AddressGeolocationUpdatePayload,
  type AddressResponse,
  type AddressSearchResult,
} from "../schemas/address";

type AddressSearchLocation = {
  latitude: number;
  longitude: number;
};

class AddressApi {
  private readonly url = "/addresses/";

  updateAddressGeolocation(
    id: number,
    payload: AddressGeolocationUpdatePayload,
  ): Promise<Result<AddressResponse>> {
    return api.patch(this.url + `${id}/`, AddressResponseSchema, {
      geolocation: payload,
    });
  }

  searchAddresses(
    query: string,
    location?: AddressSearchLocation,
  ): Promise<Result<AddressSearchResult[]>> {
    return api.get(
      this.url + "search/",
      AddressSearchResultSchema.array(),
      {
        q: query,
        ...(location ?? {}),
      },
    );
  }
}

const store = defineStore("address", () => ({
  api: markRaw(new AddressApi()),
}));

export function useAddressApi() {
  return store().api;
}
